import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';

export interface ProductImage {
  image_source: string;
  image_code: string;
}

@Component({
  selector: 'app-image-gallery',
  imports: [CommonModule, CarouselModule],
  standalone: true,
  templateUrl: './image-gallery.component.html',
  styleUrls: ['./image-gallery.component.scss'],
})
export class ImageGalleryComponent implements OnChanges {
  @Input() imageData: ProductImage[] = [];
  @Input() deviceType: 'mobile' | 'desktop' = 'desktop';

  @Output() slideChanged = new EventEmitter<number>();

  inview: boolean[] = [];

  carouselOptions: OwlOptions = {
    loop: true,
    autoWidth: true,
    dots: false,
    mouseDrag: true,
    autoplay: true,
    navSpeed: 500,
    navText: ['', ''],
    responsive: {
      0: { items: 1 },
      480: { items: 1 },
      768: { items: 1 },
      1280: { items: 1 },
    },
    nav: false,
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['imageData'] && this.imageData?.length) {
      // Initialise: first image active, rest inactive
      this.inview = this.imageData.map((_, i) => i === 0);
    }
  }

  onSlideChange(event: any): void {
    const currentIndex: number = event.startPosition;
    this.inview = this.imageData.map((_, i) => i === currentIndex);
    this.slideChanged.emit(currentIndex);
  }
}
